// extracted by mini-css-extract-plugin
module.exports = {"generics-modal":"genericsModal_generics-modal__awhLn","list":"genericsModal_list__Ym2Mg","title":"genericsModal_title__7TfUl","footer":"genericsModal_footer__Apuv0"};